module.exports = __webpack_public_path__ + "img/web.059e6dd1.svg";